// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__pYdJM","myModalContent":"MyModal_myModalContent__84POc","active":"MyModal_active__2e1Yh"};